import React, { useEffect, useState, Fragment, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { SideMenu } from '../../components/menu';
import { OneColumnLayout, TwoColumnLayout } from '../../components/layout';
import { Box, Div } from '../../components/element';
import { toggleSideMenu, getSideMenuOpenStatusAction, getArrayModelListAction } from '../../actions';
import { withTracker } from '../../utils/withTracker';
import { eventTracking } from '../../utils/eventTracker';
import { getQueryString, getQueryStringValues, validatePageQueryString } from '../../utils/withPath';
import { Feedback } from '../../components/page';
import {
  PRODUCT_ID_NIMBLE,
  PRODUCT_ID_DHCI,
  PRODUCT_ID_PRIMERA,
  ALLETRAMP_OPT_BLUETOOTH,
  OAAS_ClOUD_CONNECTION_APP,
  PRODUCT_ID_ALLETRA9k,
  PRODUCT_ID_ALLETRA6k,
  PRODUCT_ID_ALLETRA5k,
  PRODUCT_ID_DHCI_ALLETRA6K,
  PRIMERA_OPT_FIELD,
  PRODUCT_ID_BAAS,
  PRODUCT_ID_OAAS,
  PRODUCT_ID_FILE,
  PRODUCT_ID_BAAS_5K_G,
  PRODUCT_ID_BAAS_6K_B,
  PRODUCT_ID_BAAS_9K_M,
  PRODUCT_ID_PCBE,
  HPE_ALLETRA_DHCI,
  DHCI_OPT_BROWN,
  HPE_ALL_FLASH,
  HPE_HYBRID_FLASH,
  OAAS_ClOUD_CONNECT_CLI,
  MODEL_ALLETRAMP,
  HPE_SIMPLIVITY,
  EXISTING_ESXI_CLUSTER,
  PRODUCT_ID_SDS,
  MODEL_LIST_PCBE,
  PRODUCT_ID_ALLETRAB10K,
  MODEL_LIST_SWITCHED_B10K,
  CABLETRAY_OPT_YES,
} from '../../constants';
import { pagesConfig as pagesConfig5k } from '../../config/alletra5kPagesConfig';
import { pagesConfig as pagesConfig6k } from '../../config/alletra6kPagesConfig';
import { pagesConfig as pagesConfig9kField } from '../../config/alletra9kPagesConfigField';
import { pagesConfig as pagesConfig9kFactory } from '../../config/alletra9kPagesConfigFactory';
import { pagesConfig as pagesConfigMPFactoryBluetooth } from '../../config/alletraMPPagesConfigFactoryBluetooth';
import { pagesConfig as pagesConfigOaasBluetooth } from '../../config/oaasPagesConfigBluetooth.js';
import { pagesConfig as pagesConfigOaasCLI } from '../../config/oaasPagesConfigCLI.js';
import { pagesConfig as pagesConfigOaasPhysicalNetwork } from '../../config/oaasPagesConfig.js';
import { pagesConfig as pagesConfigMPFieldBluetooth } from '../../config/alletraMPPagesConfigFieldBluetooth';
import { pagesConfig as pagesConfigMPField } from '../../config/alletraMPPagesConfigField';
import { pagesConfig as pagesConfigMPFieldSwitched } from '../../config/alletraMPPagesConfigFieldSwitched';
import { pagesConfig as pagesConfigMPFieldSwitchedBluetooth } from '../../config/alletraMPPagesConfigFieldSwitchedBluetooth';
import { pagesConfig as pagesConfigMPFactorySwitched } from '../../config/alletraMPPagesConfigFactorySwitched';
import { pagesConfig as pagesConfigMPFactorySwitchedBluetooth } from '../../config/alletraMPPagesConfigFactorySwitchedBluetooth.js';
import { pagesConfig as pagesConfigMPFieldSwitchedNoCableTray } from '../../config/alletraMPPagesConfigFieldSwitchedNoCableTray.js';
import { pagesConfig as pagesConfigMPFieldSwitchedNoCableTrayBluetooth } from '../../config/alletraMPPagesConfigFieldSwitchedNoCableTrayBluetooth.js';
import { pagesConfig as pagesConfigMPFactory } from '../../config/alletraMPPagesConfigFactory';
import { pagesConfig as primeraPagesConfigField } from '../../config/primeraPagesConfigField';
import { pagesConfig as filestoragePagesConfigFactory } from '../../config/greenlakefilestorage';
import { pagesConfig as primeraPagesConfigFactory } from '../../config/primeraPagesConfigFactory';
import { pagesConfig as dHCIPagesConfig } from '../../config/dHCIPagesConfig.js';
import { dHCI6KPagesConfig } from '../../config/dHCI6KPagesConfig';
import { dHCI6KPagesConfigExistEnv } from '../../config/dHCI6KPagesConfigExistEnv.js';
// import { pagesConfigBaas6kBusiness, pagesConfigBaas9kMission } from '../../config';
import { pagesConfig as pagesConfigBaas5kBusiness } from '../../config/baas5kPagesConfig';
import { pagesConfig as pagesConfigBaas6kBusiness } from '../../config/baas6kPagesConfig';
import { pagesConfig as pagesConfigBaas9kMission } from '../../config/baas9kPagesConfig';
import { pagesConfig as privateCloudBusinessEditionConfig } from '../../config/privateCloudBusinessEdition';
import { pagesConfig as privateCloudBusinessEditionExistEnvConfig } from '../../config/privateCloudBusinessEditionExistEnv.js';
import { pagesConfig as privateCloudBusinessEditionSimplivityConfig } from '../../config/privateCloudBusinessEditionSimplivity';
import { pagesConfig as privateCloudBusinessEditionFactoryConfig } from '../../config/privateCloudBusinessEditionFactory.js';
import { pagesConfig as privateCloudBusinessEditionFieldConfig } from '../../config/privateCloudBusinessEditionField.js';
import { pagesConfig as softwareDefinedStorageforAWSConfig } from '../../config/softwareDefinedStorageforAWS';

const flattedMainPageRoutes = (pagesConfig, qsOpt = '') => {
  let prevPageIndex = null;
  return pagesConfig
    .reduce((routes, item) => {
      // convert 2 dimensional to 1 demensional
      !item.pageProps && (item.pageProps = {});
      if (item.redirectTo && typeof item.redirectTo === 'object' && item.redirectTo[qsOpt]) {
        item['redirectTo'] = item['redirectTo'][qsOpt];
      }
      // routes.push(item);
      if (item.submenuItems) {
        const submenuItems = item.submenuItems
          .filter(submenu => {
            return !submenu.opt || submenu.opt === qsOpt;
          })
          .map(submenu => {
            !submenu.pageProps && (submenu.pageProps = {});
            submenu.pageProps.category = item.menuText;
            return submenu;
          });

        item.submenuItems = [...submenuItems];
        routes.push(item);
        return routes.concat(submenuItems);
      } else {
        routes.push(item);
        return routes;
      }
    }, [])
    .map((routeItem, index, arr) => {
      // add prevPage and nextPath links
      if (routeItem.component) {
        if (prevPageIndex) {
          routeItem.pageProps.prevPage = arr[prevPageIndex].path;
          arr[prevPageIndex].pageProps.nextPage = routeItem.path.replace('/:step', '/1');
          // for wizard path
          if (routeItem.pageProps.prevPage.indexOf('/:step') !== -1) {
            const steps = arr[prevPageIndex].pageProps.steps.length;
            routeItem.pageProps.prevPage = routeItem.pageProps.prevPage.replace(':step', steps);
          }
        }
        prevPageIndex = index;
      }
      return routeItem;
    });
};

const PageRouteList = props => {
  const { pageRoutes, responsive, querString } = props;
  return pageRoutes.map((route, index) => {
    const params = {
      responsive: responsive,
      pageProps: { ...route.pageProps, pageName: route.pageName || route.menuText },
    };
    return route.redirectTo ? (
      <Route
        key={index}
        path={route.path}
        exact={route.exact}
        render={() => <Redirect to={route.redirectTo + querString} />}
      />
    ) : (
      <Route key={index} path={route.path} exact={route.exact} component={withTracker(route.component, params)} />
    );
  });
};

// class MainPage extends React.Component {
export default function MainPage(props) {
  const dispatch = useDispatch();
  const queryStringValues = getQueryStringValues(props.location);

  const querString = getQueryString(props.location);
  // const subProductId = useRecoilValue(subProductIdState);
  const [subProductId, setSubProductId] = useState('alletra9k');
  const modelList = useSelector(props => props.techDocReducer['modelList']);
  // const productName = getQueryStringValues(props.location)['product'];
  // const qsOpt = getQueryStringValues(props.location)['opt'];
  const [productName] = useState(getQueryStringValues(props.location)['product']);
  const [qsOpt, setQsOpt] = useState(getQueryStringValues(props.location)['opt']);
  const [productmodel, setProductModel] = useState(getQueryStringValues(props.location)['model']);
  const [connectMethod, setConnectMethod] = useState(getQueryStringValues(props.location)['connectopt']);
  const [configureMethod, setConfigureMethod] = useState(getQueryStringValues(props.location)['configureopt']);
  const [hpeAlletraDHCImodel, setHpeAlletraDHCIModel] = useState(
    getQueryStringValues(props.location)['hpeAlletraDHCImodel'],
  );
  const [cabletray, setCableTray] = useState(getQueryStringValues(props.location)['cabletray']);
  const [pageRoutes, setPageRoutes] = useState([]);
  const [module, setModule] = useState();
  const [storagePurchaseOpt, setStoragePurchaseOpt] = useState(
    getQueryStringValues(props.location)['storagepurchaseopt'],
  );
  const handleOnMouseDown = evt => {
    eventTracking({ evt, location: props.location });
    // evt.preventDefault();
    // evt.stopPropagation();
  };

  useEffect(() => {
    if (typeof modelList === 'undefined') {
      getArrayModelListAction(productName, dispatch);
      // return;
    }
  }, [dispatch, modelList, productName]);

  useEffect(() => {
    setQsOpt(getQueryStringValues(props.location)['opt']);
    setConnectMethod(getQueryStringValues(props.location)['connectopt']);
    setConfigureMethod(getQueryStringValues(props.location)['configureopt']);
    setHpeAlletraDHCIModel(getQueryStringValues(props.location)['hpeAlletraDHCImodel']);
    setStoragePurchaseOpt(getQueryStringValues(props.location)['storagepurchaseopt']);
    setProductModel(getQueryStringValues(props.location)['model']);
    setCableTray(getQueryStringValues(props.location)['cabletray']);
  }, [props.location]);

  useEffect(() => {
    getSideMenuOpenStatusAction(dispatch);
    window.scrollTo(0, 0);
  });
  const sideMenuOpen = useSelector(props => props.toggleSideMenu['sideMenuOpen']);

  // componentDidUpdate() {
  //   window.scrollTo(0, 0);
  // }

  // render() {
  validatePageQueryString(props.location, props.history);
  const sideMenuStyle = {
    left: sideMenuOpen ? 0 : -280,
  };

  const getPagesConfig = useCallback(
    productName => {
      const getNimblePageConfig = () => {
        import('../../config/nimblePagesConfig.js').then(module => {
          setModule(module);
        });
      };
      let configFile = null;
      switch (productName) {
        case PRODUCT_ID_NIMBLE:
          getNimblePageConfig();
          break;
        case PRODUCT_ID_PRIMERA:
          configFile = qsOpt === PRIMERA_OPT_FIELD ? 'alletra9kPagesConfigField.js' : 'alletra9kPagesConfigFactory.js';
          import(`../../config/${configFile}`).then(module => {
            setModule(module);
          });
          // import('../../config/primeraPagesConfig.js').then(module => {
          //   setModule(module);
          // });
          break;
        case PRODUCT_ID_ALLETRAB10K:
          if (MODEL_LIST_SWITCHED_B10K.includes(productmodel)) {
            if (cabletray === CABLETRAY_OPT_YES) {
              if (connectMethod === ALLETRAMP_OPT_BLUETOOTH) {
                configFile =
                  qsOpt === PRIMERA_OPT_FIELD
                    ? 'alletraMPPagesConfigFieldSwitchedBluetooth.js'
                    : 'alletraMPPagesConfigFactorySwitchedBluetooth.js';
              } else {
                configFile =
                  qsOpt === PRIMERA_OPT_FIELD
                    ? 'alletraMPPagesConfigFieldSwitched.js'
                    : 'alletraMPPagesConfigFactorySwitched.js';
              }
            } else {
              if (connectMethod === ALLETRAMP_OPT_BLUETOOTH) {
                configFile =
                  qsOpt === PRIMERA_OPT_FIELD
                    ? 'alletraMPPagesConfigFieldSwitchedNoCableTrayBluetooth.js'
                    : 'alletraMPPagesConfigFactorySwitchedBluetooth.js';
              } else {
                configFile =
                  qsOpt === PRIMERA_OPT_FIELD
                    ? 'alletraMPPagesConfigFieldSwitchedNoCableTray.js'
                    : 'alletraMPPagesConfigFactorySwitched.js';
              }
            }
          } else {
            if (connectMethod === ALLETRAMP_OPT_BLUETOOTH) {
              configFile =
                qsOpt === PRIMERA_OPT_FIELD
                  ? 'alletraMPPagesConfigFieldBluetooth.js'
                  : 'alletraMPPagesConfigFactoryBluetooth.js';
            } else {
              configFile =
                qsOpt === PRIMERA_OPT_FIELD ? 'alletraMPPagesConfigField.js' : 'alletraMPPagesConfigFactory.js';
            }
          }
          import(`../../config/${configFile}`).then(module => {
            setModule(module);
          });
          break;
        case PRODUCT_ID_OAAS:
          if (connectMethod === OAAS_ClOUD_CONNECTION_APP) {
            configFile = 'oaasPagesConfigBluetooth.js';
          } else if (connectMethod === OAAS_ClOUD_CONNECT_CLI) {
            configFile = 'oaasPagesConfigCLI.js';
          } else {
            configFile = 'oaasPagesConfig.js';
          }
          import(`../../config/${configFile}`).then(module => {
            setModule(module);
          });
          break;
        case PRODUCT_ID_ALLETRA9k:
          configFile = qsOpt === PRIMERA_OPT_FIELD ? 'primeraPagesConfigField.js' : 'primeraPagesConfigFactory.js';
          import(`../../config/${configFile}`).then(module => {
            setModule(module);
          });
          break;
        case PRODUCT_ID_BAAS:
          import('../../config/baas6kPagesConfig.js').then(module => {
            setModule(module);
          });
          break;
        case PRODUCT_ID_FILE:
          import('../../config/greenlakefilestorage.js').then(module => {
            setModule(module);
          });
          break;
        case PRODUCT_ID_PCBE:
          if (MODEL_LIST_PCBE.includes(productmodel)) {
            configFile =
              hpeAlletraDHCImodel === EXISTING_ESXI_CLUSTER
                ? 'privateCloudBusinessEditionExistEnv.js'
                : 'privateCloudBusinessEdition.js';
          } else if (productmodel === MODEL_ALLETRAMP) {
            configFile =
              qsOpt === DHCI_OPT_BROWN
                ? 'privateCloudBusinessEditionField.js'
                : 'privateCloudBusinessEditionFactory.js';
          } else {
            configFile = 'privateCloudBusinessEditionSimplivity.js';
          }
          import(`../../config/${configFile}`).then(module => {
            setModule(module);
          });
          break;
        case PRODUCT_ID_SDS:
          import('../../config/softwareDefinedStorageforAWS.js').then(module => {
            setModule(module);
          });
          break;
        default:
          getNimblePageConfig();
          break;
      }
    },
    [qsOpt, connectMethod, hpeAlletraDHCImodel, productmodel, cabletray],
  );

  useEffect(() => {
    let productId = productName;
    let model = queryStringValues.model;
    if (modelList && modelList[model]) {
      productId = modelList[model].productId;
    }
    getPagesConfig(productId);
    setSubProductId(productId);
  }, [queryStringValues, modelList, productName, connectMethod, configureMethod, hpeAlletraDHCImodel, getPagesConfig]);
  // useEffect(() => {
  //   getPagesConfig(subProductId);
  // }, [getPagesConfig, subProductId]);
  const getModulePageConfig = useCallback(
    (module, subProductId) => {
      let modulePageConfig = module.pagesConfig;
      switch (subProductId) {
        case PRODUCT_ID_ALLETRA6k:
          modulePageConfig = pagesConfig6k;
          break;
        case PRODUCT_ID_ALLETRA5k:
          modulePageConfig = pagesConfig5k;
          break;
        case PRODUCT_ID_FILE:
          modulePageConfig = filestoragePagesConfigFactory;
          break;
        case PRODUCT_ID_ALLETRAB10K:
          if (MODEL_LIST_SWITCHED_B10K.includes(productmodel)) {
            if (cabletray === CABLETRAY_OPT_YES) {
              if (connectMethod === ALLETRAMP_OPT_BLUETOOTH) {
                modulePageConfig =
                  qsOpt === PRIMERA_OPT_FIELD
                    ? pagesConfigMPFieldSwitchedBluetooth
                    : pagesConfigMPFactorySwitchedBluetooth;
              } else {
                modulePageConfig =
                  qsOpt === PRIMERA_OPT_FIELD ? pagesConfigMPFieldSwitched : pagesConfigMPFactorySwitched;
              }
              break;
            } else {
              if (connectMethod === ALLETRAMP_OPT_BLUETOOTH) {
                modulePageConfig =
                  qsOpt === PRIMERA_OPT_FIELD
                    ? pagesConfigMPFieldSwitchedNoCableTrayBluetooth
                    : pagesConfigMPFactorySwitchedBluetooth;
              } else {
                modulePageConfig =
                  qsOpt === PRIMERA_OPT_FIELD ? pagesConfigMPFieldSwitchedNoCableTray : pagesConfigMPFactorySwitched;
              }
              break;
            }
          } else {
            if (connectMethod === ALLETRAMP_OPT_BLUETOOTH) {
              modulePageConfig =
                qsOpt === PRIMERA_OPT_FIELD ? pagesConfigMPFieldBluetooth : pagesConfigMPFactoryBluetooth;
            } else {
              modulePageConfig = qsOpt === PRIMERA_OPT_FIELD ? pagesConfigMPField : pagesConfigMPFactory;
            }
          }
          break;
        case PRODUCT_ID_OAAS:
          if (connectMethod === OAAS_ClOUD_CONNECTION_APP) {
            modulePageConfig = pagesConfigOaasBluetooth;
          } else if (connectMethod === OAAS_ClOUD_CONNECT_CLI) {
            modulePageConfig = pagesConfigOaasCLI;
          } else {
            modulePageConfig = pagesConfigOaasPhysicalNetwork;
          }
          break;
        case PRODUCT_ID_ALLETRA9k:
          modulePageConfig = qsOpt === PRIMERA_OPT_FIELD ? pagesConfig9kField : pagesConfig9kFactory;
          break;
        case PRODUCT_ID_BAAS_5K_G:
          modulePageConfig = pagesConfigBaas5kBusiness;
          break;
        case PRODUCT_ID_BAAS_6K_B:
          modulePageConfig = pagesConfigBaas6kBusiness;
          break;
        case PRODUCT_ID_BAAS_9K_M:
          modulePageConfig = pagesConfigBaas9kMission;
          break;
        case PRODUCT_ID_DHCI:
          modulePageConfig = dHCIPagesConfig;
          break;
        case PRODUCT_ID_DHCI_ALLETRA6K:
          modulePageConfig = qsOpt === DHCI_OPT_BROWN ? dHCI6KPagesConfigExistEnv : dHCI6KPagesConfig;
          break;
        case PRODUCT_ID_PRIMERA:
          modulePageConfig = qsOpt === PRIMERA_OPT_FIELD ? primeraPagesConfigField : primeraPagesConfigFactory;
          break;
        case PRODUCT_ID_PCBE:
          switch (productmodel) {
            case HPE_ALLETRA_DHCI:
            case HPE_ALL_FLASH:
            case HPE_HYBRID_FLASH:
              modulePageConfig =
                hpeAlletraDHCImodel === EXISTING_ESXI_CLUSTER
                  ? privateCloudBusinessEditionExistEnvConfig
                  : privateCloudBusinessEditionConfig;
              break;
            case HPE_SIMPLIVITY:
              modulePageConfig = privateCloudBusinessEditionSimplivityConfig;
              break;
            default:
              modulePageConfig =
                qsOpt === DHCI_OPT_BROWN
                  ? privateCloudBusinessEditionFieldConfig
                  : privateCloudBusinessEditionFactoryConfig;
              break;
          }
          break;
        case PRODUCT_ID_SDS:
          modulePageConfig = softwareDefinedStorageforAWSConfig;
          break;
      }
      return modulePageConfig;
    },
    [qsOpt, connectMethod, hpeAlletraDHCImodel, productmodel, cabletray],
  );
  useEffect(() => {
    if (module && module.pagesConfig) {
      const modulePageConfig = getModulePageConfig(module, subProductId, storagePurchaseOpt);
      const _pageRoutes = flattedMainPageRoutes(modulePageConfig, qsOpt);
      setPageRoutes(_pageRoutes);
    }
  }, [
    module,
    qsOpt,
    subProductId,
    connectMethod,
    configureMethod,
    hpeAlletraDHCImodel,
    storagePurchaseOpt,
    getModulePageConfig,
  ]);
  return !module ? null : (
    <>
      <Box
        key={
          subProductId +
          qsOpt +
          connectMethod +
          configureMethod +
          storagePurchaseOpt +
          productmodel +
          hpeAlletraDHCImodel
        }
        direction="column"
        width="xxlarge"
        responsive={true}
        className="mainContainerStyle"
        onMouseDown={handleOnMouseDown}>
        {props.responsive.indexOf('small') === -1 ? (
          <TwoColumnLayout
            key={subProductId}
            module={module}
            sideMenu={
              <SideMenu
                module={module}
                pagesConfig={getModulePageConfig(module, subProductId, storagePurchaseOpt, productmodel)}
                key={
                  subProductId +
                  qsOpt +
                  connectMethod +
                  configureMethod +
                  storagePurchaseOpt +
                  productmodel +
                  hpeAlletraDHCImodel
                }
                productId={subProductId}
              />
            }
            leftNavClassName="welcomeCenterLeftNav"
            rightContentClassName="welcomeCenterContent">
            <PageRouteList pageRoutes={pageRoutes} responsive={props.responsive} querString={querString} />
          </TwoColumnLayout>
        ) : (
          <Fragment>
            <Div className="sideMenuStyle" style={sideMenuStyle} onClick={() => toggleSideMenu(false, dispatch)}>
              <SideMenu
                pagesConfig={getModulePageConfig(module, subProductId, storagePurchaseOpt, productmodel)}
                key={
                  subProductId +
                  qsOpt +
                  connectMethod +
                  configureMethod +
                  storagePurchaseOpt +
                  productmodel +
                  hpeAlletraDHCImodel
                }
                productId={subProductId}
              />
            </Div>
            <OneColumnLayout>
              {sideMenuOpen && <Div className="overlayStyle" onClick={() => toggleSideMenu(false, dispatch)} />}
              <PageRouteList pageRoutes={pageRoutes} responsive={props.responsive} querString={querString} />
            </OneColumnLayout>
          </Fragment>
        )}

        <Feedback responsive={props.responsive} />
      </Box>
    </>
  );
  // }
}

// const mapStateToProps = state => ({
//   responsiveMenu: state.toggleSideMenu,
// });

// const mapDispatchToProps = dispatch => ({
//   toggleSideMenu: model => dispatch(toggleSideMenu(model)),
// });

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(MainPage);
